import ToolDelete from '../../../tools/ToolDelete';

class ToolDeleteTable extends ToolDelete {
  static style = 'danger' as const;
  static iconClass = 'fa-regular fa-trash';
}

export default ToolDeleteTable;
